/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Test if a value is an even number.
*
* @module @stdlib/assert-is-even
*
* @example
* import isEven from '@stdlib/assert-is-even';
*
* var bool = isEven( 4.0 );
* // returns true
*
* bool = isEven( new Number( 4.0 ) );
* // returns true
*
* bool = isEven( 3.0 );
* // returns false
*
* bool = isEven( new Number( 5.0 ) );
* // returns false
*
* bool = isEven( -3.14 );
* // returns false
*
* bool = isEven( null );
* // returns false
*
* @example
* // Use interface to check for even number primitives...
* import { isPrimitive as isEven } from '@stdlib/assert-is-even';
*
* var bool = isEven( -4.0 );
* // returns true
*
* bool = isEven( new Number( -4.0 ) );
* // returns false
*
* @example
* // Use interface to check for even number objects...
* import { isObject as isEven } from '@stdlib/assert-is-even';
*
* var bool = isEven( 4.0 );
* // returns false
*
* bool = isEven( new Number( 4.0 ) );
* // returns true
*/

// MODULES //

import setReadOnly from '@stdlib/utils-define-nonenumerable-read-only-property';
import main from './main.js';
import isPrimitive from './primitive.js';
import isObject from './object.js';


// MAIN //

setReadOnly( main, 'isPrimitive', isPrimitive );
setReadOnly( main, 'isObject', isObject );


// EXPORTS //

export default main;
